import React, { useState } from 'react';
import { Header } from '../../../components/Layout/Header';
import { Content } from '../../../components/Layout/Content';
import { L } from '../../../lib/i18n';
import styled from '@emotion/styled';
import { usePromise } from '../../../lib/react';
import { NavLink } from 'react-router-dom';
import { Pagination } from '../../../components/Layout/Pagination';
import { RawHtml } from '../../../components/Layout/RawHtml';
import ContentInformationApi from '@app/api/public/ProjectContentInformationApi';
import { Button } from '@ourliving/ourliving-ui';
import { Card } from '../../../components/Layout/Card';
import { style } from '../../../components/Shared/Style';
import { Table } from '../../../components/Table/Table';
import { Icon } from '../../../components/Icon/Icon';
import { useObserver } from 'mobx-react';
import { Loading } from '../../../components/Loading/Loading';
import { SearchField } from '../../../components/SearchField/SearchField';
import { ContentInformationStore } from '../ContentInformationStore';

interface Props {
    location: { search: string };
}

const Menu = styled.div({
    display: 'flex',
    justifyContent: 'flex-end',
    paddingBottom: style.margin.s
});

const SearchMenu = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: style.margin.s
});

const TextRight = styled.div({
    textAlign: 'right'
});

const StyledNavLink = styled(NavLink)({
    textDecoration: 'none',
    color: style.colors.primary,
    lineHeight: '32px'
});

const Container = styled.div({
    display: 'flex'
});

export const InformationListPage = () => {
    const [page, setPage] = useState(0);
    const [ready, list] = usePromise(async () => {
        return await ContentInformationApi.list(page);
    }, [page]);

    const onChange = e => {
        ContentInformationStore.searchFilter = e.target.value;
    };

    const removeInfo = (id: string) => {
        ContentInformationStore.remove(id);
    };

    return useObserver(() => {
        if (!ready) {
            return <Loading />;
        }

        const f = list.items.filter(title => title.title.toLowerCase().includes(ContentInformationStore.searchFilter));

        const items = f.map(it => ({
            title: (
                <StyledNavLink to={`/information/${it.id}`}>
                    <div>{it.title}</div>
                </StyledNavLink>
            ),
            description: (
                <StyledNavLink to={`/information/${it.id}`}>
                    <RawHtml content={it.description} />
                </StyledNavLink>
            ),
            published: (
                <StyledNavLink to={`/information/${it.id}`}>
                    <div>{it.id}</div>
                </StyledNavLink>
            ),
            boardmembers: (
                <>
                    <input type="checkbox" />
                </>
            ),
            trashcan: (
                <TextRight>
                    <Icon.TrashCan onClick={() => removeInfo(it.id)} />
                </TextRight>
            )
        }));

        return (
            <>
                <Header title={L('information')} />
                <Content>
                    <Menu>
                        <StyledNavLink to={`/information/new`}>
                            <Button>{L('calendar_new')}</Button>
                        </StyledNavLink>
                    </Menu>
                    <Card background={style.colors.white}>
                        <SearchMenu>
                            <SearchField onChange={onChange} placeholder={L('search_info')} />
                            {L('amount')} {L('posts')}: {list.totalItems}
                        </SearchMenu>
                        <Container>
                            {ready && (
                                <div style={{ width: '100%' }}>
                                    <Table
                                        columns={[
                                            { key: 'title', header: L('title'), arrows: true, width: '0.5fr' },
                                            { key: 'description', header: L('info'), arrows: true, width: '0.5fr' },
                                            { key: 'published', header: L('published'), arrows: true, width: '0.5fr' },
                                            {
                                                key: 'boardmembers',
                                                header: L('boardmember_area'),
                                                arrows: true,
                                                width: '0.5fr'
                                            },
                                            {
                                                key: 'trashcan',
                                                width: '0.5fr'
                                            }
                                        ]}
                                        data={items}
                                    />
                                    <Pagination page={list} onChangePage={setPage} />
                                </div>
                            )}
                        </Container>
                    </Card>
                </Content>
            </>
        );
    });
};
